var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 25,
    viewBox: "0 0 29 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9954_37300)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3555 15.4863C14.0793 15.4863 13.8555 15.2625 13.8555 14.9863V12.3197C13.8555 12.0435 14.0793 11.8197 14.3555 11.8197C14.6316 11.8197 14.8555 12.0435 14.8555 12.3197V14.9863C14.8555 15.2625 14.6316 15.4863 14.3555 15.4863Z",
    fill: "#2E4D6B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3555 10.8203C14.0793 10.8203 13.8555 10.5965 13.8555 10.3203V9.65365C13.8555 9.3775 14.0793 9.15365 14.3555 9.15365C14.6316 9.15365 14.8555 9.3775 14.8555 9.65365V10.3203C14.8555 10.5965 14.6316 10.8203 14.3555 10.8203Z",
    fill: "#2E4D6B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3548 7.48633C11.6854 7.48633 9.52148 9.65029 9.52148 12.3197C9.52148 14.989 11.6854 17.153 14.3548 17.153C17.0242 17.153 19.1882 14.989 19.1882 12.3197C19.1882 9.65029 17.0242 7.48633 14.3548 7.48633ZM8.52148 12.3197C8.52148 9.098 11.1332 6.48633 14.3548 6.48633C17.5765 6.48633 20.1882 9.098 20.1882 12.3197C20.1882 15.5413 17.5765 18.153 14.3548 18.153C11.1332 18.153 8.52148 15.5413 8.52148 12.3197Z",
    fill: "#2E4D6B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33127 6.95463C9.53324 7.14295 9.5443 7.45934 9.35597 7.6613C8.21743 8.88232 7.52148 10.5195 7.52148 12.3203C7.52148 14.1211 8.21743 15.7583 9.35597 16.9793C9.5443 17.1813 9.53324 17.4977 9.33127 17.686C9.12931 17.8743 8.81292 17.8633 8.6246 17.6613C7.32027 16.2625 6.52148 14.3841 6.52148 12.3203C6.52148 10.2565 7.32027 8.37814 8.6246 6.97933C8.81292 6.77736 9.12931 6.7663 9.33127 6.95463Z",
    fill: "#2E4D6B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3797 6.95463C19.5817 6.7663 19.8981 6.77736 20.0864 6.97933C21.3907 8.37814 22.1895 10.2565 22.1895 12.3203C22.1895 14.3841 21.3907 16.2625 20.0864 17.6613C19.8981 17.8633 19.5817 17.8743 19.3797 17.686C19.1778 17.4977 19.1667 17.1813 19.355 16.9793C20.4936 15.7583 21.1895 14.1211 21.1895 12.3203C21.1895 10.5195 20.4936 8.88232 19.355 7.6613C19.1667 7.45934 19.1778 7.14295 19.3797 6.95463Z",
    fill: "#2E4D6B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9954_37300"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(6.35547 4.32031)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBl);
export default __webpack_public_path__ + "static/media/bl.5510a5c88fb80933f46c9fb14484c823.svg";
export { ForwardRef as ReactComponent };